module.exports = __webpack_public_path__ + "static/media/exportDocsLogo512.22ab56f4.png";